<p>file-upload works!</p>
<form [formGroup]='dataForm' (ngSubmit)='uploadFile()'>
    <input type='file' name='profile' (change)="onFileChange($event)"/>
    <button type='submit'>Upload</button>
</form>
<!-- <img [src]='imageUrl'> -->